import { useTranslation } from 'react-i18next';
import { Chip, ColorsV2, Text, spaces, useThemeColors } from '@electricjs/arc';

type AutomationStatusChipProps = {
  id: string;
  isAutomated: boolean;
};

const AutomationStatusChip = ({
  id,
  isAutomated,
}: AutomationStatusChipProps) => {
  const { t } = useTranslation('common');
  const [warningBg, warningText, primaryBg, primaryText] = useThemeColors([
    ColorsV2.WARNING_LIGHTEST,
    ColorsV2.WARNING_DARKEST,
    ColorsV2.PRIMARY_LIGHTEST,
    ColorsV2.PRIMARY_DARKEST,
  ]);

  if (isAutomated) {
    return (
      <Chip
        id={`${id}-automated-chip`}
        variant="small"
        backgroundColor={primaryBg}
        textColor={primaryText}
        icon="bolt"
        pl={spaces.space_s_rem}>
        <Text variant="legal" color={primaryText}>
          {t('automationStatus.automated')}
        </Text>
      </Chip>
    );
  }

  return (
    <Chip
      id={`${id}-manual-chip`}
      variant="small"
      backgroundColor={warningBg}
      textColor={warningText}
      icon="alert-triangle"
      pl={spaces.space_s_rem}>
      <Text variant="legal" color={warningText}>
        {t('automationStatus.manual')}
      </Text>
    </Chip>
  );
};

export { AutomationStatusChip };
